var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#a3bde3",
    height: "256px",
    width: "256px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 489.475 489.475",
    xmlSpace: "preserve",
    stroke: "#a3bde3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M487.823,468.675v-346.4c0-8.3-4.2-15.6-11.4-18.7l-223.7-102c-5.2-2.1-11.4-2.1-16.6,0l-223.7,102 c-7.3,3.1-11.4,10.4-11.4,18.7v346.4c0,11.4,9.4,20.8,20.8,20.8s20.8-9.4,20.8-20.8v-332.9l203.9-92.6l202.8,92.6v332.9 c0,11.4,9.4,20.8,20.8,20.8S491.023,480.175,487.823,468.675z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.123,285.575c11.4,0,20.8-9.4,20.8-20.8v-134.2c0-11.4-9.4-20.8-20.8-20.8h-134.2c-11.4,0-20.8,9.4-20.8,20.8v134.2 c0,11.4,9.4,20.8,20.8,20.8H313.123z M199.723,152.475h92.6v92.6h-92.6V152.475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.223,313.675h-134.2c-11.4,0-20.8,9.4-20.8,20.8v134.2c0,11.4,9.4,20.8,20.8,20.8h134.2c11.4,0,20.8-9.4,20.8-20.8 v-134.2C234.023,323.075,224.623,313.675,213.223,313.675z M192.423,448.975h-92.6v-92.6h92.6V448.975z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.923,313.675h-134.2c-11.4,0-20.8,9.4-20.8,20.8v134.2c0,11.4,9.4,20.8,20.8,20.8h134.2c11.4,0,20.8-9.4,20.8-20.8 v-134.2C433.723,323.075,424.423,313.675,412.923,313.675z M392.123,448.975h-92.6v-92.6h92.6V448.975z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.51fc7069e61d2c260f78e6bdf2abd6ca.svg";
export { ForwardRef as ReactComponent };